// TODO Figure out how env should be defined and exported.  Re-exporting
//      an ES6 module of unknown variables is problematic.
//
//      Exporting single vars in such a way that you might import a subset
//      doesn't work as I believe it's actually impossible to re-export that.
//
//      Exporting an object default 1. transforms it into a module which can
//      lead to unexpected behavior, one example of which below, you have to
//      re-export `default.default` to ship the object.
//
//      The answer might be for the base lib to export `{ env }`, which would
//      be easy to target and re-export... but is more cumbersome to consume.
import env from '@maui-mf/env'
export default env
